import React, { useState, useEffect } from "react";
import { List, Modal, notification } from "antd";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import axios from "axios";
import { DragHandle } from "../../../../components/DragHandle";

const Ordering = ({ isOpen, onClose, datas, moduleName, base_url }) => {
  const [datalist, setDatalist] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDatalist(datas || []);
  }, [datas]);

  // -----------------------------
  // Save reordered list
  // -----------------------------

  const handleOrder = async () => {
    try {
      setLoading(true);

      const orderedIds = datalist.map((item) => item._id);

      const { data } = await axios.post(`${base_url}/reorder`, {
        orderedIds,
      });

      notification.success({
        message: `${moduleName} order updated successfully`,
      });

      if (onClose) onClose(data.data);
    } catch (err) {
      console.error(err);
      notification.error({ message: "Failed to update order" });
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------
  // Drag reorder
  // -----------------------------

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const temp = Array.from(datalist);

    const [moved] = temp.splice(result.source.index, 1);
    temp.splice(result.destination.index, 0, moved);

    setDatalist(temp);
  };

  return (
    <Modal
      title={`Reorder ${moduleName}`}
      visible={isOpen}
      onOk={handleOrder}
      okText="Update"
      confirmLoading={loading}
      onCancel={() => onClose()}
    >
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="catalog-ordering">
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ maxHeight: 400, overflow: "auto" }}
            >
              <List
                bordered
                dataSource={datalist}
                renderItem={(item, index) => (
                  <Draggable
                    key={item._id}
                    draggableId={item._id}
                    index={index}
                  >
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef}>
                        <List.Item
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                            boxShadow: snapshot.isDragging
                              ? "0 0 .4rem #666"
                              : "none",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {/* Catalog Name */}

                          <span style={{ flex: 1, fontWeight: 600 }}>
                            {item.name}
                          </span>

                          {/* Drag Handle */}

                          <span style={{ width: 40, textAlign: "right" }}>
                            <DragHandle {...provided.dragHandleProps} />
                          </span>
                        </List.Item>
                      </div>
                    )}
                  </Draggable>
                )}
              />

              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Modal>
  );
};

export default Ordering;
